import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <>
      <section className="chapter">
        {/* <div className="chapter__headerBar" />
        <p className="chapter__title">The Invasion</p> */}

        <p className="chapter__paragraph">
          Farmers around the world are on the verge of catastrophe. The COVID-19 pandemic and the
          war in Ukraine have snarled supply chains and sent the price of food and fuel spiking in
          nations across the globe. Governments and organizations around the world sounded the alarm
          about the growing potential for global food insecurity.
        </p>
        <div className="chapter__splitBlock">
          <div className="chapter__splitBlock__pg">
            <p className="chapter__paragraph ">
              These same factors have also made it difficult for farms to secure the workers they
              need. In the U.S., for example, worker shortages are “threatening our domestic
              capacity to produce a safe and robust supply,” according to the USDA, which is
              pursuing new grant programs to address the problem. At the same time, production costs
              for growers in the USA are growing at an unprecedented rate—up 17.8% in the last year.
            </p>
          </div>
          <div className="chapter__splitBlock__image">
            {/* <img src={splitBlockImg1} alt="graphic of vegetables" /> */}
            <video playsInline autoPlay muted loop width="335" height="356">
              <source
                src="https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/blueWhiteVeggies.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </section>
    </>
  );
}

export default Chapter1;
